import * as cart from './cart';
import * as sales from './sales';

export default function initAxiosForms() {
    window.axios = require('axios');
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    window.toast = (message) => {
        const currentNode = document.getElementById('toaster');
        if (currentNode) {
            currentNode.remove();
        }

        const messageNode = document.createElement('div');
        messageNode.id = 'toaster';
        messageNode.classList.add('show');
        messageNode.innerHTML = message;
        document.body.appendChild(messageNode);
        setTimeout(function () {
            messageNode.classList.remove('show');
        }, 3000);
    }

    document.addEventListener('submit', async (e) => {
        if (e.target && e.target.classList && e.target.classList.contains('axios')) {
            e.preventDefault();
            const form = e.target;

            if (form.classList.contains('loading')) {
                return;
            }

            form.classList.add('loading');

            const url = form.action + '?rest_language=' + document.documentElement.lang.split('-')[0];
            const method = form.method.toLowerCase();
            const data = new FormData(form);

            const generalErrors = form.querySelectorAll('.general-error');
            for (const el of generalErrors) {
                if (!el.classList.contains('axios-no-remove')) {
                    el.remove();
                }
            }

            const generalSuccess = form.querySelectorAll('.general-success');
            for (const el of generalSuccess) {
                if (!el.classList.contains('axios-no-remove')) {
                    el.remove();
                }
            }

            const fields = form.querySelectorAll('.input');
            for (const el of fields) {
                el.classList.remove('invalid');
            }

            const messageFields = form.querySelectorAll('.input-error');
            for (const el of messageFields) {
                el.remove();
            }

            let response;

            try {
                if (method === 'get') {
                    response = await axios.get(url);
                } else if (method === 'post') {
                    response = await axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}});
                }

                response = response.data;
            } catch (error) {
                response = error.response.data;
            }

            if (response.clear) {
                for (const el of form.querySelectorAll('.axios-clear')) {
                    el.value = '';
                }
            }

            if (response && response.errors && Object.keys(response.errors).length) {
                let topMostError = null;

                for (let i = 0, keys = Object.keys(response.errors), ii = keys.length; i < ii; i++) {
                    const input = form.querySelector("[name='" + keys[i] + "']");

                    if (input) {
                        input.classList.add('invalid');

                        const messageNode = document.createElement('span');
                        messageNode.classList.add('input-error');
                        messageNode.innerHTML = response.errors[keys[i]];
                        input.parentNode.insertBefore(messageNode, input.nextSibling);

                        if (!topMostError) {
                            topMostError = input;
                        } else {
                            if (topMostError.getBoundingClientRect().top > input.getBoundingClientRect().top) {
                                topMostError = input;
                            }
                        }
                    }
                }

                form.classList.remove('loading');

                if (topMostError) {
                    window.scroll({
                        top: topMostError.getBoundingClientRect().top + window.scrollY - 150,
                        behavior: 'smooth',
                    });
                }

            } else if (response && response.general_error) {
                const messageNode = document.createElement('span');
                messageNode.classList.add('general-error');
                messageNode.innerHTML = response.general_error;
                form.appendChild(messageNode);
                form.classList.remove('loading');

            } else if (response && response.general_silent_success) {
                form.classList.remove('loading');
                //Silent success

            } else if (response && response.general_success) {
                const messageNode = document.createElement('span');
                messageNode.classList.add('general-success');
                messageNode.innerHTML = response.general_success;
                form.appendChild(messageNode);
                form.classList.remove('loading');

                if (response.hide) {
                    messageNode.classList.add('p-0');

                    for (const el of form.querySelectorAll('.axios-hide')) {
                        el.classList.add('d-none');
                    }
                }

            } else if (response && response.action) {
                switch (response.action[0].toLowerCase()) {
                    case 'redirect':
                        window.location.href = response.action[1];
                        break;
                    case 'reload':
                        location.reload();
                        break;
                    case 'toast':
                        form.classList.remove('loading');
                        window.toast(response.action[1]);
                        break;
                    case 'cart':
                        form.classList.remove('loading');
                        cart.processResponse(form, response.action);
                        break;
                    case 'cartmembership':
                        form.classList.remove('loading');
                        cart.preProcessMembershipResponse(form, response.action);
                        break;
                    case 'cartcoupon':
                        form.classList.remove('loading');
                        cart.processServiceCouponResponse(form, response.action);
                        break;
                    case 'click':
                        form.classList.remove('loading');
                        const element1 = document.getElementById(response.action[1]);

                        if (element1) {
                            element1.click();
                        }
                        break;
                    case 'toastandclick':
                        form.classList.remove('loading');
                        const element2 = document.getElementById(response.action[1]);
                        window.toast(response.action[2]);

                        if (element2) {
                            element2.click();
                        }
                        break;
                    case 'discountadd':
                        form.classList.remove('loading');
                        cart.processDiscountAdd(form, response.action);
                        break;
                    case 'sumcodeadd':
                        form.classList.remove('loading');
                        cart.processSumCodeAdd(form, response.action);
                        break;
                    case 'processcouponsend':
                        form.classList.remove('loading');
                        sales.processCouponSendResponse(form, response.action);
                        break;
                }
            } else {
                const messageNode = document.createElement('span');
                messageNode.classList.add('general-error');
                let globalErrorMessage = document.getElementById('global_axios_validator_error');

                if (!globalErrorMessage) {
                    globalErrorMessage = 'An error occurred';
                } else {
                    globalErrorMessage = globalErrorMessage.innerHTML;
                }

                messageNode.innerHTML = globalErrorMessage;
                form.appendChild(messageNode);
                form.classList.remove('loading');
            }
        }
    });

    for (const checkbox of document.querySelectorAll('input[type=checkbox]')) {
        if (checkbox.hasAttribute('data-toggle')) {
            const toggleElement = document.querySelector('.' + checkbox.getAttribute('data-toggle'));

            if (toggleElement) {
                checkbox.addEventListener('click', () => {
                    if (toggleElement.classList.contains('d-none')) {
                        toggleElement.classList.remove('d-none');
                    } else {
                        toggleElement.classList.add('d-none');
                    }
                });
            }
        }
    }
}
